<template>
  <v-navigation-drawer
    :width="width"
    mobile-break-point="599"
    :class="menuClass"
  >
    <v-layout
      column
      justify-center
    >
      <v-flex>
        <v-layout
          v-if="mobileScreen"
          align-center
          justify-center
          class="main-menu__header"
        >
          <h3 class="display-2 display-2_dark">
            {{ $t('menu.menu') }}
          </h3>
          <a
            class="main-menu__close"
            @click="hideMenu()"
          >
            <baseIcon>
              <closeIcon :icon-color="$vuetify.theme.sz_grafit" />
            </baseIcon>
          </a>
        </v-layout>
        <AppLogo
          v-else
          class="m-auto"
        />
      </v-flex>
      <v-list class="main-menu">
        <v-list-tile v-if="mobileScreen && $store.getters['featuresVisible']">
          <v-list-tile-action>
            <baseIcon>
              <profileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
            </baseIcon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $store.getters['auth/getUserFullName'] }}</v-list-tile-title>
        </v-list-tile>
        <mainMenuItem
          v-for="(item, index) in menuItems"
          :key="index"
          :item="item"
        />
        <v-list-tile v-if="mobileScreen">
          <v-list-tile-action>
            <baseIcon>
              <logoutIcon :icon-color="$vuetify.theme.sz_medium_grey" />
            </baseIcon>
          </v-list-tile-action>
          <v-list-tile-title>
            <AppLogout />
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
import mainMenuItem from '@/components/widgets/menu/MainMenuItem';
import baseIcon from '@/icons/BaseIcon';
import closeIcon from '@/icons/CloseIcon';
import logoutIcon from '@/icons/LogoutIcon';
import profileIcon from '@/icons/ProfileIcon';
import AppLogout from '@/components/widgets/menu/AppLogout';

export default {
    name: 'MainMenu',
    components: {
        AppLogo,
        mainMenuItem,
        closeIcon,
        baseIcon,
        AppLogout,
        logoutIcon,
        profileIcon
    },
    data () {
        return {
            width: 136,
            mainMenu: null
        };
    },
    computed: {
        menuItems () {
            return this.mainMenu.getMenu();
        },
        mobileScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        activeMenu () {
            return this.$store.getters['mainMenu/getActiveMenu'];
        },
        menuClass () {
            let _class = '';
            if (!this.mobileScreen) {
                _class = 'py-2';
            }
            if (this.mobileScreen && this.activeMenu) {
                _class = 'show';
            } else if (this.mobileScreen && !this.activeMenu) {
                _class = 'hide';
            }
            return _class;
        }
    },
    created () {
        const mainMenu = require('@/constants/mainMenu').default;
        this.mainMenu = mainMenu;
        this.hideMenu();
    },
    methods: {
        hideMenu () {
            this.$store.commit('mainMenu/setActiveMenu', false);
        }
    }
};
</script>

<style scoped></style>
